import { useState } from "react";
import { Flex, FormLabel, Icon, Text } from "@chakra-ui/react";
import  GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { IconBaseProps } from "react-icons";

interface SearchGoogleProps {
	onLocationSelected: (data: any) => void;
	label: string;
	icon?: React.ComponentType<IconBaseProps>;
}


const SearchGoogle: React.FC<SearchGoogleProps> = ({
	onLocationSelected,
	label,
	icon,
 }) => {
	const [value, setValue] = useState(null);

	return (
		<Flex flexDir="column">
			<FormLabel pl="2" pb="0" mb="1" fontWeight="400">
				<Flex align="center">
					{icon && (<Icon as={icon} fontSize="18" mr="2" />)}
					<Text fontSize="18">{label}</Text>
				</Flex>
			</FormLabel>

			<GooglePlacesAutocomplete
				apiOptions={{
					language: 'pt',
					region: 'pt'
				}}
				selectProps={{
					value,
					placeholder: "Buscar endereço",
					onChange: onLocationSelected,
					onBlur: () => setValue(null),
					styles: {
						control: (provided: any, state: any) => ({
							...provided,
							padding: '5px',
							border: state.isFocused ? '1px solid #2196f3' : '1px solid #eeeef2',
							background: state.isFocused ? 'white' : '#eeeef2',
              borderRadius: '8px',
              svg: { color: '#9699b0' },
							"&:hover": {
								background: !state.isFocused && '#d1d2dc',
								borderColor: state.isFocused ? '#2196f3' : '#d1d2dc',
								color: '#2196f3',
							},
						}),
						/* placeholder: (provided: any, state: any) => ({
							...provided,
							color: '#797d9a',
							// '&:hover': {color: '#eeeef2'},
						}), */
						container: (provided: any) => ({
							...provided,
						}),
						input: (provided: any) => ({
							...provided,
						}),
						options: (provided: any) => ({
							...provided,
						})
					},
				}}
			/>
		</Flex>
	)
}

export default SearchGoogle;
